import { render, staticRenderFns } from "./AdminSocietyForm.vue?vue&type=template&id=19733dfb&scoped=true"
import script from "./AdminSocietyForm.vue?vue&type=script&lang=js"
export * from "./AdminSocietyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19733dfb",
  null
  
)

export default component.exports